(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationPropertySearch', PublicSiteTranslationPropertySearch);

    PublicSiteTranslationPropertySearch.$inject = ['$resource'];

    function PublicSiteTranslationPropertySearch($resource) {
        var resourceUrl =  'api/_search/public-site-translation-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
